import React, { useEffect } from 'react'
import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'
import { useChapterAction } from '@hooks/chapter/useChapterAction'
import { useAlert } from '@hooks/useAlert'
import { WithChapterPageProps, ChapterPageProps } from './interface'

export function withChapterPage(Component: React.FC<ChapterPageProps>) {
  function WithChapterPage({ bookId, chapterId }: WithChapterPageProps) {
    const { replace } = useRouter()
    const alert = useAlert()
    const chapterClient = useChapterAction()
    const {
      theme,
      fontSize,
      lineHeight,
      fontFamily,
      setInitialData,
      setThemeFromLocalStorage,
    } = useTheme()
    const { data } = useQuery(
      ['my-writing', bookId, 'chapter', chapterId],
      () => chapterClient.bookChapterPreview(chapterId),
      {
        onError: () => {
          alert.error('ขออภัย คุณไม่ใช่เจ้าของเรื่องนี้')
          replace('/my-writing')
        },
      }
    )

    useEffect(() => {
      setThemeFromLocalStorage()

      return () => {
        setInitialData()
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const pageProps = {
      theme,
      bookId,
      chapterId,
      data,
      fontSize,
      lineHeight,
      fontFamily,
    }

    return <Component {...pageProps} />
  }
  return WithChapterPage
}
